import getPathReduxUtil from 'modules/redux/utils/get-path'
import isNewReduxUtil from 'modules/redux/utils/is-new'
import setUtil from 'utils/set'
import createPointerCreateReduxUtil from 'modules/redux/actions/create/create-pointer'
import { getObjectUtil } from 'packages/src'

export default function createSingleAssociationCreateReduxUtil (payload) {
  const {
    stateWrapper,
    association,
    existingInstance,
    isLocal,
    instance,
    dataPath,
    properties,
    associationKey
  } = payload
  let existingAssociation
  if (existingInstance && isNewReduxUtil(existingInstance)) {
    existingAssociation = getObjectUtil(stateWrapper.state, `${getPathReduxUtil(existingInstance)}.changed.${associationKey}`)
  }
  const pointer = createPointerCreateReduxUtil(stateWrapper, {
    existingInstance: existingAssociation
      ? getObjectUtil(stateWrapper.state, getPathReduxUtil(existingAssociation))
      : null,
    referencePath: `${getPathReduxUtil(instance)}.${dataPath}`,
    association,
    properties,
    isLocal
  })
  return setUtil(instance, dataPath, pointer)
}
